<template>
	<div class="aboutCertificates">
		<my-header active="0" />
		<div class="main">
			<div class="container">
				<div class="current ">
					<p>当前位置：首页>帮助中心</p>
				</div>
                <div class="warp">
                    <examination-sidebar />
                    <div class="sidebar-right">
                        <ul>
                            <li>
                                <div class="titleTop">
                                    <img src="../assets/images/public/Q.jpg" alt="">
                                    <h1>如何报名考试？</h1>
                                </div>
                                <p>若要使用xxxx电子服务有限公司(xxxx)网站中的任何内容或信息，请您阅读使用条款。请注意访问和/或使用本网站(如复制任何信息等)，即表示您接受这些使用条款。如果不接受这些使用条款，请离开并停止使用本网站。</p>
                            </li>
                            <li>
                                <div class="titleTop">
                                    <img src="../assets/images/public/Q.jpg" alt="">
                                    <h1>如何报名考试？</h1>
                                </div>
                                <p>若要使用xxxx电子服务有限公司(xxxx)网站中的任何内容或信息，请您阅读使用条款。请注意访问和/或使用本网站(如复制任何信息等)，即表示您接受这些使用条款。如果不接受这些使用条款，请离开并停止使用本网站。</p>
                            </li>
                            <li>
                                <div class="titleTop">
                                    <img src="../assets/images/public/Q.jpg" alt="">
                                    <h1>如何报名考试？</h1>
                                </div>
                                <p>若要使用xxxx电子服务有限公司(xxxx)网站中的任何内容或信息，请您阅读使用条款。请注意访问和/或使用本网站(如复制任何信息等)，即表示您接受这些使用条款。如果不接受这些使用条款，请离开并停止使用本网站。</p>
                            </li>
                            <li>
                                <div class="titleTop">
                                    <img src="../assets/images/public/Q.jpg" alt="">
                                    <h1>如何报名考试？</h1>
                                </div>
                                <p>若要使用xxxx电子服务有限公司(xxxx)网站中的任何内容或信息，请您阅读使用条款。请注意访问和/或使用本网站(如复制任何信息等)，即表示您接受这些使用条款。如果不接受这些使用条款，请离开并停止使用本网站。</p>
                            </li>
                            <li>
                                <div class="titleTop">
                                    <img src="../assets/images/public/Q.jpg" alt="">
                                    <h1>如何报名考试？</h1>
                                </div>
                                <p>若要使用xxxx电子服务有限公司(xxxx)网站中的任何内容或信息，请您阅读使用条款。请注意访问和/或使用本网站(如复制任何信息等)，即表示您接受这些使用条款。如果不接受这些使用条款，请离开并停止使用本网站。</p>
                            </li>
                        </ul>
                        <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="getList" />
                    </div>
                </div>
            </div>
            <my-footer />
        </div>   
    </div>
</template>

<script>
import pagination from '@/components/pagination'

export default {
	name: 'helpCenter',
	components: {
        pagination
	},
	data(){
		return {
            listQuery: {
				page: 1,
				limit: 20,
			},
			total:100,
		}
	},
	mounted(){
		
    },
    methods:{
		getList(){
			this.$message('获取列表')
		}
	}
}
</script>

<style scoped>
ul{
    margin-bottom: 35px;
}
ul li{
    font-size: 14px;
    /* border-bottom: 1px dashed #e6e6e6; */
    padding: 10px 20px;
}
ul li h1{
    font-size: 18px;
    font-weight: bold;
    line-height: 35px;
}
ul li span{
    font-size: 14px;
    color: #666;
    line-height: 28px;
}
ul li p{
    font-size: 14px;
    padding-top: 10px;
    padding-left: 47px;
}
.titleTop{
    display: flex;
}
.titleTop img{
    margin-right: 10px;
}
</style>
